import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ApiConstant } from '../../../../constants';
import { Banner, BannerText } from './component';
import './index.css';

const Endpoint = ApiConstant.BASE_URL + 'challenge/';

const BY_PASS_SENIORITY = ['Experience Ineligible', 'Undefined', 'Junior'];

const SeniorityBanner = () => {
  const token = localStorage.getItem('token');
  if (token) {
    axios.defaults.headers.common.Authorization = token;
  }
  const [seniority, setSeniority] = useState(null);

  const fetchData = async () => {
    try {
      const body = {
        action: 'GET_USER_EXPERIENCE_SENIORITY_INFO'
      };
      const response = await axios.post(Endpoint, body);
      const data = response.data;
      if (data.success) {
        if (data.result) {
          let seniorityLevel = data.result[0].seniority;
          if (seniorityLevel && seniorityLevel.toLowerCase() === 'mid level') seniorityLevel = 'Experienced';
          setSeniority(BY_PASS_SENIORITY.includes(seniorityLevel) ? null : seniorityLevel);
        }
      }
    } catch (e) {

    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Banner>
      <BannerText seniority={seniority} />
    </Banner>
  );
};

export default SeniorityBanner;
